<script>
import Endpoints from '../../../components/common/Endpoints';
import Request from '../../../components/common/Request';

export default {
    init: async(payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
    },
    methods:{
        sendMessage: function(){
            console.log(this.to);
            this.$socket.emit('message', { from: this.user._id, to: this.from._id, msg: this.data.msg, room: this.conversationId });
            this.data.msg = "";
        },
        listConversations: function(){
            let state = this;
            state.conversations = [];
            
            Request.do(state, 'GET', Request.getDefaultHeader(state), null, `${Endpoints.chat.conversations}`,
            (response)=>{//SUCCESS CALLBACK
                state.conversations = response.results;

                if (response.results.length > 0 && state.conversationId == null){
                    state.selectItem(response.results[0]);
                }
            },
            (error)=>{//ERROR CALLBACK
            });
        },
        selectItem: function(item){
            if (item){
                let state = this;
                state.messages = [];

                this.conversationId = item.conversationId;
                this.from = item.from;

                this.$socket.emit('room', item.conversationId);

                Request.do(state, 'POST', Request.getDefaultHeader(state), { conversationId : item.conversationId }, `${Endpoints.chat.filter}`,
                (response)=>{//SUCCESS CALLBACK
                    state.messages = response.results;

                    setTimeout(()=>{
                        var element = document.getElementById('messages');
                        element.scrollTop = element.scrollHeight;
                    }, 400);
                },
                (error)=>{//ERROR CALLBACK
                });
            }
        },
        addUser(){
              $('#modalAddUserChat').modal('toggle');
        }
    }
}
</script>
